import React, { useEffect, Fragment } from "react";
import { connect } from "react-redux";
import SvgIcons from "../Icons/SvgIcons";
import { isAgentVisible } from "../../schemas/commonAccess";

const PingPilotHeaderButton = (props) => {

  const { pingPilotAuthToken, language, willSetCurrentUser, activeEntity } = props;

  const agentIsVisible = isAgentVisible();

  useEffect(() => {
    let pilotScript = document.getElementById('pingPilotScript');
    if (!agentIsVisible) {
      if (pilotScript) {
        document.body.removeChild(pilotScript);
      }
      return
    }
    if (!pilotScript) {
      pilotScript = document.createElement('script');
      pilotScript.setAttribute('type', 'text/javascript');
      pilotScript.setAttribute('id', 'pingPilotScript');
      pilotScript.setAttribute('src', 'https://quote.pingpilot.com/');
      document.body.appendChild(pilotScript);
    }
    if (pilotScript) {
      pilotScript.setAttribute('data-token', pingPilotAuthToken);
      pilotScript.setAttribute('data-language', language);
    }
  }, [pingPilotAuthToken, language, willSetCurrentUser, activeEntity]);

  if (!agentIsVisible) {
    return null
  }

  return (
    <div className="central-hub-svg-icon central-hub-agent-icon" id="pingPilotHeaderButton">
      {SvgIcons.coBrowseIcon}
    </div>
  )
};

const mapStateToProps = (store) => {
  const { pingPilotAuthToken } = store.auth;
  const { language } = store.dashboardState;
  const { willSetCurrentUser, activeEntity } = store.asCustomer;

  return {
    pingPilotAuthToken,
    language,
    willSetCurrentUser,
    activeEntity
  };
};

export default connect(mapStateToProps)(PingPilotHeaderButton);
